import { render, staticRenderFns } from "./Old.vue?vue&type=template&id=1dca2c60&scoped=true&"
import script from "./Old.vue?vue&type=script&lang=js&"
export * from "./Old.vue?vue&type=script&lang=js&"
import style0 from "./Old.vue?vue&type=style&index=0&id=1dca2c60&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dca2c60",
  null
  
)

export default component.exports